(() => {
  if (window.__richMessOutsideMenuCloseBound) return;
  window.__richMessOutsideMenuCloseBound = true;

  document.addEventListener(
    'pointerdown',
    (event) => {
      const details = document.querySelector('header-drawer details[open]');
      if (!details) return;

      const drawer = details.querySelector('#menu-drawer, .menu-drawer');
      if (!drawer) return;

      if (drawer.contains(event.target)) return;

      const rect = drawer.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;

      const clickedOutsideDrawer =
        x < rect.left ||
        x > rect.right ||
        y < rect.top ||
        y > rect.bottom;

      if (!clickedOutsideDrawer) return;

      event.preventDefault();
      event.stopPropagation();

      const headerDrawer = details.closest('header-drawer');
      const summary = details.querySelector('summary');

      if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
        headerDrawer.closeMenuDrawer(event, summary || false);
        return;
      }

      details.classList.remove('menu-opening');
      details.removeAttribute('open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('overflow-hidden-mobile');
    },
    true
  );
})();